import React from "react";
import { Link } from "gatsby";

import SEO from '../components/seo';
import Topbar from '../components/topbar';
import Navbar from '../components/navigation-bar';

import AppFeature from '../components/app-feature';
import Update from '../components/update';

import DLogo from '../images/Landing_Dlogo.svg';
import OurGoals1 from '../images/Consitent03.svg';
import OurGoals2 from '../images/Assisting.svg';
import OurGoals3 from '../images/Educational.svg';
import DesignGuide from '../images/Guidebutton_designer.svg';
import DeveloperGuide from '../images/Guidebutton_developer.svg';
import FeedbackImage from '../images/Feedbacks.svg';
import '../styles/main.css';
import '../styles/index.css';


export default () => <>
	<link href="https://fonts.googleapis.com/css?family=Montserrat:300,400,600,700&display=swap" rel="stylesheet"></link>
	<SEO title='Landing' />
	<Topbar />
	<Navbar />
	<div className="main">
		<section className='main-section-1'>
			<div className="ms1-text">
				<h2>Build NYU Products Easier</h2>
				<p>
					<b>TorchUI Design System</b> is a tool
					that helps you create clear and consistent
					layouts and styles across prodcuts for the
					NYU community.
				</p>
			</div>
			<img className="ms1-image" src={DLogo} alt='Torch UI Design Letter' />
		</section>

		<section className='main-section-2'>
			<h2 className="ms2-text">Our Goal</h2>
			<div>
				<AppFeature image={OurGoals1} title='Consistent'>
					A single repository that directs and manage a consistent style for our products
				</AppFeature>
				<AppFeature image={OurGoals2} title='Assisting'>
					A solution which precisely solve the problem for both designers and developers
				</AppFeature>
				<AppFeature image={OurGoals3} title='Educational'>
					A guideline for training new designers and developers
				</AppFeature>
			</div>
		</section>

		<section className='main-section-3'>
			<h2 className="ms3-text">Getting Started</h2>
			<div>
				<Link to='/designers-guide'>
					<img src={DesignGuide} alt='designer guide' className='ms3-box'></img>
				</Link>
				<Link to='/developers-guide'>
					<img src={DeveloperGuide} alt='developer guide' className='ms3-box'></img>
				</Link>
			</div>
		</section>

		<section className='main-section-4'>
			<h2 className="ms4-text-1">Feedback</h2>
			<h4 className="ms4-text-2">Feedback is always welcome!</h4>
			<img src={FeedbackImage} alt='feedback icons'/>
			<button className='outline-button'>Send Feedback</button>
		</section>

		<section className='main-section-5'>
			<h2 className="ms5-text">Updates</h2>
			<Update date='OCTOBER 17, 2019' title='Accessible Imagery' link='https://localhost:8000'>
				New guidance for alt tags, color contrast, and making imagery understandable to more users
			</Update>
			<Update date='NOVEMBER 17, 2019' title='Accessible Imagery' link='https://localhost:8000'>
				New guidance for alt tags, color contrast, and making imagery understandable to more users
			</Update>
		</section>
	</div>
</>